import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { SweetAlertDirective } from '../sweet-alert.directive';
import { FileUpload } from '../file-upload/file-upload.component';
import { CommonService } from 'projects/services/src/app/API/nsdccommonService/common.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { BatchService } from 'projects/services/src/app/API/batch.service';

declare var swal: any;

@Component({
    selector: 'app-evidence-submission',
    templateUrl: './evidence-submission.component.html',
    styleUrls: ['./evidence-submission.component.css']
})
export class EvidenceSubmissionComponent implements OnInit {
    @ViewChild(SweetAlertDirective) appSweetAlert: SweetAlertDirective;
    @Input() batchData: any;
    tcPerMisesDocumentOne: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    tcPerMisesDocumentTwo: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    groupPhotoGraph: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    regularIntervalPicOne: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    regularIntervalPicTwo: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    regularIntervalPicThree: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    regularIntervalPicFour: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    regularIntervalPicFive: FileUpload = {
        type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
        defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
    };
    eviedenceForm: FormGroup;
    role: any;
    baseUrl = 'https://nsdcproddocuments.s3.ap-south-1.amazonaws.com';
    message = 'success';
    @Output() messageEvent = new EventEmitter<string>();
    isSubmitted: boolean;
    defaultUrl = '../../../../assets/images/loader.svg'
    reason: any;
    signedUrl = {
        'tcPerMisesPicOne': this.defaultUrl,
        'tcPerMisesPicTwo': this.defaultUrl,
        'groupPhotoGraph': this.defaultUrl,
        'regularIntervalPicOne': this.defaultUrl,
        'regularIntervalPicTwo': this.defaultUrl,
        'regularIntervalPicThree': this.defaultUrl,
        'regularIntervalPicFour': this.defaultUrl,
        'regularIntervalPicFive': this.defaultUrl,



    }

    renderControl = {
        'tcPerMisesPicOne': false,
        'tcPerMisesPicTwo': false,
        'groupPhotoGraph': false,
        'regularIntervalPicOne': false,
        'regularIntervalPicTwo': false,
        'regularIntervalPicThree': false,
        'regularIntervalPicFour': false,
        'regularIntervalPicFive': false,
    }

    modalShow = false;
    modalleft;
    modaltop;
    zoneIsClicked;
    tempImage: any;
    constructor(
        private fb: FormBuilder,
        private commonService: CommonService,
        private userService: CurrentUserService,
        private totService: TotBatchService,
        private fileService: FileService,
        private batchService: BatchService
    ) { }

    ngOnInit() {
        console.log("BATCH DATA FOR EVIDENCE UPLOAD ", this.batchData);
        this.userService.getCurrentUser().subscribe(user => {
            this.role = user && user.role;
        })
        this.createForm();
        // this.formEvent();
        // this.patchForm()
        if (this.role !== 'Assessor' && this.role !== 'Assessment Agency') {
            this.disableAllFields();
        }
    }
    addClickEvent(e, imageUrl, type) {
        if (e.type === 'click') {
            this.modalShow = true;
            this.zoneIsClicked = true;
        }
        /*else if (e.type === 'mousemove') {
          this.modalleft = e.clientX
          this.modaltop = e.clientY
        }*/
        else if (e.type === 'mouseenter') {
            this.modalShow = true;
            this.zoneIsClicked = false;
            this.modalleft = e.clientX
            this.modaltop = e.clientY
            this.tempImage = imageUrl;

            if (type === 'tcPerMisesPicOne') {
                this.renderControl.tcPerMisesPicOne = true;

            } else if (type === 'tcPerMisesPicTwo') {
                this.renderControl.tcPerMisesPicTwo = true;

            } else if (type === 'groupPhotoGraph') {
                this.renderControl.groupPhotoGraph = true;

            } else if (type === 'regularIntervalPicOne') {
                this.renderControl.regularIntervalPicOne = true;

            } else if (type === 'regularIntervalPicTwo') {
                this.renderControl.regularIntervalPicTwo = true;

            } else if (type === 'regularIntervalPicThree') {
                this.renderControl.regularIntervalPicThree = true;

            } else if (type === 'regularIntervalPicFour') {
                this.renderControl.regularIntervalPicFour = true;

            } else if (type === 'regularIntervalPicFive') {
                this.renderControl.regularIntervalPicFive = true;

            }


            // swal({
            //   title: 'Sweet!',
            //   text: 'Modal with a custom image.',
            //   imageUrl: imageUrl,
            //   imageWidth: 400,
            //   imageHeight: 200,
            //   imageAlt: 'Custom image',
            // })
        }
        else if (e.type === 'mouseleave') {
            this.modalShow = false;

            if (type === 'tcPerMisesPicOne') {
                this.renderControl.tcPerMisesPicOne = false;

            } else if (type === 'tcPerMisesPicTwo') {
                this.renderControl.tcPerMisesPicTwo = false;

            } else if (type === 'groupPhotoGraph') {
                this.renderControl.groupPhotoGraph = false;

            } else if (type === 'regularIntervalPicOne') {
                this.renderControl.regularIntervalPicOne = false;

            } else if (type === 'regularIntervalPicTwo') {
                this.renderControl.regularIntervalPicTwo = false;

            } else if (type === 'regularIntervalPicThree') {
                this.renderControl.regularIntervalPicThree = false;

            } else if (type === 'regularIntervalPicFour') {
                this.renderControl.regularIntervalPicFour = false;

            } else if (type === 'regularIntervalPicFive') {
                this.renderControl.regularIntervalPicFive = false;

            }

            this.tempImage = ''

        }
    }

    isAssessor() {
        if (this.role === 'Assessor' || (this.role === "Proctor" && this.batchData.jobRoles[0].assessmentAgencyDetails.proctorDetails.assessmentProctorOption === "physical") || (this.role === "Assessment Agency" && this.batchData.jobRoles[0].assessmentAgencyDetails.proctorDetails && this.batchData.jobRoles[0].assessmentAgencyDetails.proctorDetails.assessmentProctorOption === "remoteAuto")) {
            return true;
        } else {
            return false
        }
    }

    isNotShowButton() {
        /// need to update
        const actionInfo = this.batchData && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails
            && this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo &&
            this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action || ''
        console.log(actionInfo);
        console.log(this.role);
        console.log(this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails)
        if (this.role === 'Assessment Agency') {
            if (actionInfo.includes("OFFLINE_ASSMT_") && actionInfo.includes("_SUBMITTED")
                || actionInfo === 'OFFLINE_ASSMT_SSC_SENT_BACK') {
                if (actionInfo !== 'OFFLINE_ASSMT_AA_SUBMITTED') {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
            // || actionInfo === 'OFFLINE_ASSMT_AA_APPROVED'

            // || actionInfo === 'OFFLINE_ASSMT_SSC_APPROVED'
            // || actionInfo === 'OFFLINE_ASSMT_AA_SENT_BACK'
            //   if (actionInfo !== 'OFFLINE_ASSMT_AA_SUBMITTED')
            // {
            //   return true;
            // } else {
            //   return false;
            // }
        } else if (this.role === 'SSC') {
            if (
                // actionInfo === 'OFFLINE_ASSMT_AR_SUBMITTED' ||
                // actionInfo === 'OFFLINE_ASSMT_SSC_SENT_BACK' ||
                // actionInfo === 'OFFLINE_ASSMT_SSC_APPROVED' ||
                // actionInfo === 'OFFLINE_ASSMT_AA_APPROVED' || 'OFFLINE_ASSMT_AA_SUBMITTED'
                actionInfo === 'OFFLINE_ASSMT_SSC_APPROVED'
            ) {
                return false;
            } else if (actionInfo === 'OFFLINE_ASSMT_AA_APPROVED' || 'OFFLINE_ASSMT_AA_SUBMITTED') {
                return true;
            }
            else {
                return false;
            }
        }

        // return (this.batchData && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails
        // 	&& this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo &&
        // 	this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action &&
        // 	(this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action == 'OFFLINE_ASSMT_AR_SUBMITTED' ||
        // 	this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action == 'OFFLINE_ASSMT_AA_APPROVED' ||
        // this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action == 'OFFLINE_ASSMT_AA_SENT_BACK') ? true : false )
    }

    isNotAssessor() {
        console.log(this.role)
        if (this.role !== 'Assessor') {
            return true;
        } else {
            return false
        }
    }

    isNotProctor() {
        console.log(this.role)
        if (this.role !== 'Proctor') {
            return true;
        } else {
            return false
        }
    }

    // For proctor

    isUploadEvidenceByAA() {
        console.log(this.role)
        if (this.role !== 'Assessor' && this.role !== 'Proctor' && (this.role === "Assessment Agency" && this.batchData.jobRoles[0].assessmentAgencyDetails.proctorDetails && this.batchData.jobRoles[0].assessmentAgencyDetails.proctorDetails.assessmentProctorOption !== "remoteAuto")) {
            return true;
        } else {
            return false
        }
    }

    disableAllFields() {
        // this.eviedenceForm.get('otherReason').disable();
        this.eviedenceForm.get('tcPerMisesPicOne').disable();
        this.eviedenceForm.get('tcPerMisesPicTwo').disable();
        this.eviedenceForm.get('groupPhotoGraph').disable();
        this.eviedenceForm.get('regularIntervalPicOne').disable();
        this.eviedenceForm.get('regularIntervalPicTwo').disable();
        this.eviedenceForm.get('regularIntervalPicThree').disable();
        this.eviedenceForm.get('regularIntervalPicFour').disable();
        this.eviedenceForm.get('regularIntervalPicFive').disable();
    }

    createForm() {
        this.eviedenceForm = this.fb.group({
            reason: [''],
            otherReason: [''],
            tcPerMisesPicOne: ['', [Validators.required]],
            tcPerMisesPicTwo: ['', [Validators.required]],
            groupPhotoGraph: ['', [Validators.required]],
            regularIntervalPicOne: ['', [Validators.required]],
            regularIntervalPicTwo: ['', [Validators.required]],
            regularIntervalPicThree: ['', [Validators.required]],
            regularIntervalPicFour: ['', [Validators.required]],
            regularIntervalPicFive: ['', [Validators.required]],
        })

        this.patchForm();
    }

    resetPic() {
        this.eviedenceForm.get('tcPerMisesPicOne').setValue(null)
        this.eviedenceForm.get('tcPerMisesPicTwo').setValue(null)
        this.eviedenceForm.get('groupPhotoGraph').setValue(null)
        this.eviedenceForm.get('regularIntervalPicOne').setValue(null)
        this.eviedenceForm.get('regularIntervalPicTwo').setValue(null)
        this.eviedenceForm.get('regularIntervalPicThree').setValue(null)
        this.eviedenceForm.get('regularIntervalPicFour').setValue(null)
        this.eviedenceForm.get('regularIntervalPicFive').setValue(null)

    }

    formEvent() {
        this.eviedenceForm.get('reason').valueChanges.subscribe(value => {
            if (value === 'Others') {
                this.eviedenceForm.get('otherReason').setValidators([Validators.required, Validators.pattern('^([a-zA-Z0-9][a-zA-Z0-9 .-_,/@!#()]*)$')]);
                this.eviedenceForm.get('otherReason').updateValueAndValidity();
                this.eviedenceForm.get('otherReason').setValue("");
                this.resetPic();
                this.tcPerMisesDocumentOne = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
                };
            } else {
                this.eviedenceForm.get('otherReason').setValidators([]);
                this.eviedenceForm.get('otherReason').setValue("");
                this.resetPic();
                this.eviedenceForm.get('otherReason').updateValueAndValidity();
                this.tcPerMisesDocumentOne = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'Relevant Document Proof',
                };
            }
        })
    }

    fileUploaded(event, type, subType) {
        if (type === 'tcPermises') {
            if (subType === 'one') {
                this.eviedenceForm.get('tcPerMisesPicOne').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            } else if (subType === 'two') {
                this.eviedenceForm.get('tcPerMisesPicTwo').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            }
        } else if (type === 'groupPhotoGraph') {
            this.eviedenceForm.get('groupPhotoGraph').patchValue(event.url)
            this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });

        } else if (type === 'intervalsPic') {
            if (subType === 'one') {
                this.eviedenceForm.get('regularIntervalPicOne').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            } else if (subType === 'two') {
                this.eviedenceForm.get('regularIntervalPicTwo').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            } else if (subType === 'three') {
                this.eviedenceForm.get('regularIntervalPicThree').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            } else if (subType === 'four') {
                this.eviedenceForm.get('regularIntervalPicFour').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            } else if (subType === 'five') {
                this.eviedenceForm.get('regularIntervalPicFive').setValue(event.url);
                this.appSweetAlert.toastrAlert({ alertType: 'success', message: `${event.name} file uploaded successfully` });
            }
        }

    }

    onFileUploadCancel(event, type, subType) {
        if (type === 'tcPermises') {
            if (subType === 'one') {
                this.eviedenceForm.get('tcPerMisesPicOne').patchValue(null);
            } else if (subType == 'two') {
                this.eviedenceForm.get('tcPerMisesPicTwo').patchValue(null);
            }
        } else if (type === 'groupPhotoGraph') {
            this.eviedenceForm.get('groupPhotoGraph').patchValue(null)
        } else if (type === 'intervalsPic') {
            if (subType === 'one') {
                this.eviedenceForm.get('regularIntervalPicOne').setValue(null);

            } else if (subType === 'two') {
                this.eviedenceForm.get('regularIntervalPicTwo').setValue(null);

            } else if (subType === 'three') {
                this.eviedenceForm.get('regularIntervalPicThree').setValue(null);

            } else if (subType === 'four') {
                this.eviedenceForm.get('regularIntervalPicFour').setValue(null);

            } else if (subType === 'five') {
                this.eviedenceForm.get('regularIntervalPicFive').setValue(null);

            }
        }

    }


    mapPayload() {
        const DATA = {
            "docDetails": {
                "tcLocPhotographs": [
                    {
                        "docID": "TC_DOC_01",
                        "docURL": {
                            "key": this.eviedenceForm.get('tcPerMisesPicOne').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('tcPerMisesPicOne').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    },
                    {
                        "docID": "TC_DOC_02",
                        "docURL": {
                            "key": this.eviedenceForm.get('tcPerMisesPicTwo').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('tcPerMisesPicTwo').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    }
                ],
                "groupPhotographs": [
                    {
                        "docID": "GP_01",
                        "docURL": {
                            "key": this.eviedenceForm.get('groupPhotoGraph').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('groupPhotoGraph').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    }
                ],
                "assmtIntervalsPhotographs": [
                    {
                        "docID": "AI_01",
                        "docURL": {
                            "key": this.eviedenceForm.get('regularIntervalPicOne').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('regularIntervalPicOne').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    },
                    {
                        "docID": "AI_02",
                        "docURL": {
                            "key": this.eviedenceForm.get('regularIntervalPicTwo').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('regularIntervalPicTwo').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    },
                    {
                        "docID": "AI_03",
                        "docURL": {
                            "key": this.eviedenceForm.get('regularIntervalPicThree').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('regularIntervalPicThree').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    },
                    {
                        "docID": "AI_04",
                        "docURL": {
                            "key": this.eviedenceForm.get('regularIntervalPicFour').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('regularIntervalPicFour').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    },
                    {
                        "docID": "AI_04",
                        "docURL": {
                            "key": this.eviedenceForm.get('regularIntervalPicFive').value,
                            "bucket": "nsdcproddocuments",
                            "location": this.baseUrl + '/' + this.eviedenceForm.get('regularIntervalPicFive').value
                        },
                        "docUploadedOn": new Date().toISOString()
                    }
                ]
            }
        }
        console.log(DATA);

        return DATA;
    }


    trigerApi(status) {
        const batchId = this.batchData && this.batchData.batchId || null;
        const qpCode = this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].qpCode || null;
        const version = this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].version || '';
        return this.totService.uploadEvidence(batchId, qpCode, version, status, this.mapPayload())

    }

    isAllFieldEmpty() {
        const picOne = this.eviedenceForm.get('tcPerMisesPicOne').value || ''
        const picTwo = this.eviedenceForm.get('tcPerMisesPicTwo').value || ''
        const picThree = this.eviedenceForm.get('groupPhotoGraph').value || ''
        const picFour = this.eviedenceForm.get('regularIntervalPicOne').value || ''
        const picFive = this.eviedenceForm.get('regularIntervalPicTwo').value || ''
        const picSix = this.eviedenceForm.get('regularIntervalPicThree').value || ''
        const picSeven = this.eviedenceForm.get('regularIntervalPicFour').value || ''
        const picEight = this.eviedenceForm.get('regularIntervalPicFive').value || ''

        if (picOne === '' && picTwo === '' && picThree === '' && picFour === '' && picFive === '' &&
            picSix === '' && picSeven === '' && picEight === '') {
            return true;
        } else {
            return false;
        }
    }

    submit(status) {
        let msg;
        if (status === 'SUBMITTED') {
            msg = 'Submitted Succesfully.'
        } else if (status === 'PENDING') {
            msg = 'Drafted Successfully'
        }

        if (status === 'PENDING') {
            this.trigerApi(status).subscribe(res => {
                if (res) {
                    swal({
                        title: msg,
                        type: 'success',
                        showDenyButton: true,
                        showCancelButton: false,
                        confirmButtonText: `OK`,
                    }).then((result) => {
                        this.messageEvent.emit('done')
                        /* Read more about isConfirmed, isDenied below */
                        console.log(result);
                        if (result.isConfirmed) {
                            // GO TO ANOTHER PAGE
                        } else {
                            // STAY HERE
                            this.close()
                        }
                    })
                }
            })
        } else {
            this.commonService.confirmationSwal('submit').then((action: any) => {
                if (action.value) {
                    this.trigerApi(status).subscribe(res => {
                        if (res) {
                            swal({
                                title: msg,
                                type: 'success',
                                showDenyButton: true,
                                showCancelButton: false,
                                confirmButtonText: `OK`,
                            }).then((result) => {
                                this.messageEvent.emit('done')
                                /* Read more about isConfirmed, isDenied below */
                                console.log(result);
                                if (result.isConfirmed) {
                                    // GO TO ANOTHER PAGE
                                } else {
                                    // STAY HERE
                                    this.close()
                                }
                            })
                        }
                    })
                }
            })
        }

    }

    takeAction(actionType) {
        let msg;
        if (actionType === 'SENDBACK') {
            msg = 'Send Back'
        } else if (actionType === 'ACCEPT') {
            msg = 'Approve'
        } else if (actionType === 'REJECT') {
            msg = 'Reject'
        }

        if (actionType !== 'ACCEPT') {
            this.closeSSCAAModal()
            swal({
                title: 'Are you sure you want to ' + msg,
                input: 'textarea',
                type: 'info',
                // html: '<input type="text" id="reason-text" placeholder="Please Enter Other Reason" class="swal2-input">',
                customClass: 'swal-wide',
                inputPlaceholder: 'Enter Comment',
                inputValidator: (value) => {
                    // const reason = swal.getContent().querySelector('#reason-text').value
                    if (!value) {
                        return !value && 'Comment is mandatory.';
                    } else {
                        this.reason = value
                    }
                },
                showCancelButton: true,
            }).then(res => {
                if ((res && res.value)) {
                    if (actionType === 'REJECT') {
                        /// API Call for Reject
                        this.triggerAPIForAASSC('REJECTED');
                    } else if (actionType === 'SENDBACK') {
                        /// API Call for Send Back
                        this.triggerAPIForAASSC('SENTBACK');
                    }
                }
            });
        } else {
            swal({
                title: 'Are you sure you want to continue?',
                type: 'info',
                confirmButtonText: 'Yes',
                showCancelButton: true,
                cancelButtonText: 'No',
                cancelButtonColor: '#d33',
            }).then((action: any) => {
                if (action.value) {
                    /// API Call for Accept
                    this.triggerAPIForAASSC('APPROVED');
                } else {
                    return;
                }
            })
        }
    }

    successMessage(type) {
        this.messageEvent.emit('close')
        swal({
            title: `${type} Successfully`,
            type: 'success',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `OK`,
        }).then((result) => {

            /* Read more about isConfirmed, isDenied below */
            console.log(result);
            if (result.isConfirmed) {
                // GO TO ANOTHER PAGE
            } else {
                // STAY HERE
                this.closeSSCAAModal()
            }
        })
    }

    triggerAPIForAASSC(actionType) {
        const data = {
            "status": actionType,
            "review": this.reason || ''
        }
        const paramData = {
            batchId: this.batchData && this.batchData.batchId || null,
            qpCode: this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].qpCode || null,
            version: this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].version || ''
        }
        this.batchService.offlineAssessmentApproval(data, paramData).subscribe(res => {
            if (res) {
                Helpers.closeModal('reason_modal')
                Helpers.closeModal('viewEvidence')
                Helpers.closeModal('evidenceModal')
                if (actionType === 'APPROVED') {
                    actionType = 'Approved'
                } else if (actionType === 'SENTBACK') {
                    actionType = 'Sent Back';
                } else if (actionType === 'REJECTED') {
                    actionType = 'Rejected';
                }

                this.successMessage(actionType) /// todo - call after api success

            }
        })
    }

    close() {
        this.closeModals()
        this.eviedenceForm = this.fb.group({
            reason: [''],
            otherReason: [''],
            tcPerMisesPicOne: ['', [Validators.required]],
            tcPerMisesPicTwo: ['', [Validators.required]],
            groupPhotoGraph: ['', [Validators.required]],
            regularIntervalPicOne: ['', [Validators.required]],
            regularIntervalPicTwo: ['', [Validators.required]],
            regularIntervalPicThree: ['', [Validators.required]],
            regularIntervalPicFour: ['', [Validators.required]],
            regularIntervalPicFive: ['', [Validators.required]],
        })
        this.tcPerMisesDocumentOne = {
            type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: 'Choose File', required: true,
            defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
        };
    }

    closeModals() {
        Helpers.closeModal('evidenceModal')
        Helpers.closeModal('viewEvidence')
        this.messageEvent.emit('close')
    }

    closeSSCAAModal() {
        Helpers.closeModal('evidenceModal')
        Helpers.closeModal('viewEvidence')
    }

    // submitResaon() {
    //   const batchId = this.batchData && this.batchData.batchId || null;
    // 	const qpCode = this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].qpCode || null;
    // 	const version = this.batchData && this.batchData.jobRoles && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].version || '1.0';
    //   const payload = {
    //     "offlineAssessmentDetails": {
    //           "reason" : this.eviedenceForm.get('reason').value,
    //           "reasonDetails" : this.eviedenceForm.get('otherReason').value
    //       }
    //   }
    //   this.totService.submitReason(batchId, qpCode, version, payload).subscribe(res => {
    //     console.log('reason updated', res);
    //   })
    // }

    isDocAvail() {
        const isDocAvail = this.batchData && this.batchData.jobRoles &&
            this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails &&
            this.batchData.jobRoles[0].offlineAssessmentDetails.docDetails || null;
        if (isDocAvail) {
            return true;
        } else {
            return false;
        }

    }

    disableFields(status) {
        if ((status.includes("OFFLINE_ASSMT_") && status.includes("_SUBMITTED")) || status === 'OFFLINE_ASSMT_SSC_APPROVED' ||
            status === 'OFFLINE_ASSMT_AA_APPROVED' || status === 'OFFLINE_ASSMT_AA_REJECTED' ||
            status === 'OFFLINE_ASSMT_AA_REJECTED' || status === 'OFFLINE_ASSMT_SSC_REJECTED'
        ) {
            this.isSubmitted = true;
        }
    }

    isSubmittedDoc() {
        const actionInfo = this.batchData && this.batchData.jobRoles[0] && this.batchData.jobRoles[0] &&
            this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo &&
            this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action || '';
        if (actionInfo === '') {
            return true;
        } else {
            return false;
        }
    }

    assignValueToUploadFile(value, type) {
        if (value) {
            let idx = value.split("/").length - 1;
            value = value.split("/")[idx].split("_")[1];
            if (type === 'tcPerMisesPicOne') {
                this.tcPerMisesDocumentOne = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'tcPerMisesPicTwo') {
                this.tcPerMisesDocumentTwo = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'groupPhotoGraph') {
                this.groupPhotoGraph = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'regularIntervalPicOne') {
                this.regularIntervalPicOne = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'regularIntervalPicTwo') {
                this.regularIntervalPicTwo = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'regularIntervalPicThree') {
                this.regularIntervalPicThree = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'regularIntervalPicFour') {
                this.regularIntervalPicFour = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            } else if (type === 'regularIntervalPicFive') {
                this.regularIntervalPicFive = {
                    type: ['png', 'jpg', 'jpeg'], size: 5000000, placeholder: value, required: true,
                    defaultMessage: 'File size upto 5mb (Allowed formats jpg, png, jpeg)', fieldName: 'TC/Location Premises Document',
                };
            }
        }

    }

    patchForm() {
        const projectionPoint = this.batchData && this.batchData.jobRoles &&
            this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails;
        this.disableFields(projectionPoint && projectionPoint.actionInfo && projectionPoint.actionInfo.action)
        const TcLocdocProjectPoint = projectionPoint && projectionPoint.docDetails &&
            projectionPoint.docDetails.tcLocPhotographs && projectionPoint.docDetails.tcLocPhotographs

        const GroupdocProjectPoint = projectionPoint && projectionPoint.docDetails &&
            projectionPoint.docDetails.groupPhotographs && projectionPoint.docDetails.groupPhotographs

        const AssmntdocProjectPoint = projectionPoint && projectionPoint.docDetails &&
            projectionPoint.docDetails.assmtIntervalsPhotographs && projectionPoint.docDetails.assmtIntervalsPhotographs
        this.eviedenceForm.get('reason').patchValue(projectionPoint && projectionPoint.reason);
        this.eviedenceForm.get('otherReason').patchValue(projectionPoint && projectionPoint.reasonDetails);
        this.eviedenceForm.get('reason').disable()
        this.eviedenceForm.get('otherReason').disable();

        const tcLocDocUrlOne = TcLocdocProjectPoint && TcLocdocProjectPoint[0] &&
            TcLocdocProjectPoint[0].docURL &&
            TcLocdocProjectPoint[0].docURL.key
        this.eviedenceForm.get('tcPerMisesPicOne').patchValue(
            tcLocDocUrlOne
        )
        this.assignValueToUploadFile(tcLocDocUrlOne, 'tcPerMisesPicOne');
        this.renderPhoto('tcPermisesOne', tcLocDocUrlOne);
        const tcPermisesTwo = TcLocdocProjectPoint && TcLocdocProjectPoint[1] &&
            TcLocdocProjectPoint[1].docURL &&
            TcLocdocProjectPoint[1].docURL.key
        this.eviedenceForm.get('tcPerMisesPicTwo').patchValue(
            tcPermisesTwo
        )
        this.renderPhoto('tcPerMisesPicTwo',
            tcPermisesTwo
        );
        this.assignValueToUploadFile(tcPermisesTwo, 'tcPerMisesPicTwo');
        const groupPhotoUrl = GroupdocProjectPoint && GroupdocProjectPoint[0] &&
            GroupdocProjectPoint[0].docURL &&
            GroupdocProjectPoint[0].docURL.key

        this.eviedenceForm.get('groupPhotoGraph').patchValue(
            groupPhotoUrl
        )
        this.assignValueToUploadFile(groupPhotoUrl, 'groupPhotoGraph')
        this.renderPhoto('groupPhotoGraph',
            groupPhotoUrl
        );
        const regularIntervalPicOneUrl = AssmntdocProjectPoint && AssmntdocProjectPoint[0] &&
            AssmntdocProjectPoint[0].docURL &&
            AssmntdocProjectPoint[0].docURL.key
        this.eviedenceForm.get('regularIntervalPicOne').patchValue(
            regularIntervalPicOneUrl
        )
        this.assignValueToUploadFile(regularIntervalPicOneUrl, 'regularIntervalPicOne')
        this.renderPhoto('regularIntervalPicOne',
            regularIntervalPicOneUrl
        );
        const regularIntervalPicTwoUrl = AssmntdocProjectPoint && AssmntdocProjectPoint[1] &&
            AssmntdocProjectPoint[1].docURL &&
            AssmntdocProjectPoint[1].docURL.key
        this.eviedenceForm.get('regularIntervalPicTwo').patchValue(
            regularIntervalPicTwoUrl
        )
        this.assignValueToUploadFile(regularIntervalPicTwoUrl, 'regularIntervalPicTwo')

        this.renderPhoto('regularIntervalPicTwo',
            regularIntervalPicTwoUrl
        );
        const regularIntervalPicThreeUrl = AssmntdocProjectPoint && AssmntdocProjectPoint[2] &&
            AssmntdocProjectPoint[2].docURL &&
            AssmntdocProjectPoint[2].docURL.key
        this.eviedenceForm.get('regularIntervalPicThree').patchValue(
            regularIntervalPicThreeUrl
        )
        this.assignValueToUploadFile(regularIntervalPicThreeUrl, 'regularIntervalPicThree')

        this.renderPhoto('regularIntervalPicThree',
            regularIntervalPicThreeUrl
        );
        const regularIntervalPicFourUrl = AssmntdocProjectPoint && AssmntdocProjectPoint[3] &&
            AssmntdocProjectPoint[3].docURL &&
            AssmntdocProjectPoint[3].docURL.key
        this.eviedenceForm.get('regularIntervalPicFour').patchValue(
            regularIntervalPicFourUrl
        )
        this.assignValueToUploadFile(regularIntervalPicFourUrl, 'regularIntervalPicFour')

        this.renderPhoto('regularIntervalPicFour',
            regularIntervalPicFourUrl
        );
        const regularIntervalPicFiveUrl = AssmntdocProjectPoint && AssmntdocProjectPoint[4] &&
            AssmntdocProjectPoint[4].docURL &&
            AssmntdocProjectPoint[4].docURL.key
        this.eviedenceForm.get('regularIntervalPicFive').patchValue(
            regularIntervalPicFiveUrl
        )
        this.assignValueToUploadFile(regularIntervalPicFiveUrl, 'regularIntervalPicFive')

        this.renderPhoto('regularIntervalPicFive',
            regularIntervalPicFiveUrl
        );
        console.log(this.eviedenceForm.getRawValue());


    }

    renderPhoto(type, url) {
        if (url) {

            this.fileService.getS3SignedURLPublic(url).subscribe(res => {
                if (type === 'tcPermisesOne') {
                    this.signedUrl.tcPerMisesPicOne = res;
                } else if (type === 'tcPerMisesPicTwo') {
                    this.signedUrl.tcPerMisesPicTwo = res;
                } else if (type === 'groupPhotoGraph') {
                    this.signedUrl.groupPhotoGraph = res;
                } else if (type === 'regularIntervalPicOne') {
                    this.signedUrl.regularIntervalPicOne = res;
                } else if (type === 'regularIntervalPicTwo') {
                    this.signedUrl.regularIntervalPicTwo = res;
                } else if (type === 'regularIntervalPicThree') {
                    this.signedUrl.regularIntervalPicThree = res;
                } else if (type === 'regularIntervalPicFour') {
                    this.signedUrl.regularIntervalPicFour = res;
                } else if (type === 'regularIntervalPicFive') {
                    this.signedUrl.regularIntervalPicFive = res;
                }
            })

        }
    }

    checkOfflineAssessmentValidity(batchList) {
        const today = new Date()
        batchList.filter(batch => {
            const isAssessmentStarted = batch.jobRoles[0].assessmentAgencyDetails &&
                batch.jobRoles[0].assessmentAgencyDetails.assessorDetails &&
                batch.jobRoles[0].assessmentAgencyDetails.assessorDetails.inTime &&
                batch.jobRoles[0].assessmentAgencyDetails.assessorDetails.inTime !== '' ? true : false
            // if (assmtStDate < currentDate) && ((assmtStDate + 2) >= currentDate) {
            // !isAssessmentStarted &&
            if (!isAssessmentStarted && batch && batch.jobRoles && batch.jobRoles[0].assessmentStartDate) {
                const assessmentDate = new Date(batch.jobRoles[0].assessmentStartDate)
                const diff = Helpers.calculateDuration(batch.jobRoles[0].assessmentStartDate, today)
                const twoDaysDiff = Helpers.calculateDuration(today, assessmentDate)
                console.log('days', diff, twoDaysDiff);
                console.log('dates', today, assessmentDate, assessmentDate);
                if (diff < 0 && (twoDaysDiff > 1 && twoDaysDiff <= 3)) {
                    console.log('assessmentDate', assessmentDate, today, batch.jobRoles[0].assessmentStartDate, twoDaysDiff);
                    batch.showOfllineAssessmentOption = true;
                } else {
                    batch.showOfllineAssessmentOption = false
                }
            }
        })
    }

    isSubmitAllowed() {
        const actionInfo = this.batchData && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails
            && this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo &&
            this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action || ''
        if (actionInfo === 'OFFLINE_ASSMT_SSC_SENT_BACK' || actionInfo === 'OFFLINE_ASSMT_AA_SENT_BACK' ||
            actionInfo === 'OFFLINE_ASSMT_AR_INITIAL' || actionInfo === 'OFFLINE_ASSMT_AR_PENDING' ||
            actionInfo === 'OFFLINE_ASSMT_PR_INITIAL' || actionInfo === 'OFFLINE_ASSMT_PR_PENDING' ||
            actionInfo === 'OFFLINE_ASSMT_AA_INITIAL' || actionInfo === 'OFFLINE_ASSMT_AA_PENDING'
        ) {
            return true;
        } else {
            return false;
        }
    }

    isSSCSendBack() {
        const actionInfo = this.batchData && this.batchData.jobRoles[0] && this.batchData.jobRoles[0].offlineAssessmentDetails
            && this.batchData.jobRoles[0].offlineAssessmentDetails && this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo &&
            this.batchData.jobRoles[0].offlineAssessmentDetails.actionInfo.action || ''
        console.log(actionInfo)
        if (actionInfo === 'OFFLINE_ASSMT_SSC_SENT_BACK') {
            return false;
        } else {
            return true;
        }
    }
}
